import React, {useState, useEffect, useContext, createContext} from 'react';
import { useAccordionContext } from './Accordion';
import { useSearchContext } from '../../Search/Provider';

const PanelContext = createContext();

export const usePanelContext = () => {
    return useContext(PanelContext);
};

const Panel = ({title, children}) => {
    const {updatePanelInfo, updatePanelErrors} = useAccordionContext(); // updatePanelWarnings

    const [fieldsWithValues, setFieldsWithValues] = useState({});
    const [fieldsWithErrors, setFieldsWithErrors] = useState({});

    const updateFieldValue = (field, hasValue) => {
        setFieldsWithValues(prev => ({
            ...prev,
            [field]: hasValue,
        }));
    }

    const updateFieldError = (field, hasError) => {
        setFieldsWithErrors(prev => ({
            ...prev,
            [field]: hasError,
        }));
    }

    useEffect(() => {
        const count = Object.values(fieldsWithValues).filter(v => v).length;
        updatePanelInfo(title, count);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, fieldsWithValues]);

    useEffect(() => {
        const count = Object.values(fieldsWithErrors).filter(v => v).length;
        updatePanelErrors(title, count);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, fieldsWithErrors]);

    const providerValues = {
        updateFieldValue,
        updateFieldError,
    };

    return <div className="p-2">
        <PanelContext.Provider value={providerValues}>
            {children}
        </PanelContext.Provider>
    </div>
}

const useFieldPanelHelper = (name, value, isValid) => {
    const panel = usePanelContext();
    const search = useSearchContext();

    useEffect(() => {
        if (!panel) {
            return;
        }

        let filteredValue = value;

        if (search && search.hasConditionsFilter) {
            filteredValue = search.hasConditionsFilter({[name]: value})?.[name];
        }

        panel.updateFieldValue(
            name,
            filteredValue !== null && filteredValue !== undefined && filteredValue !== '' && (!Array.isArray(filteredValue) || filteredValue.length > 0)
        );
        panel.updateFieldError(name, !isValid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, value, isValid]);
}

export default Panel;

export {
    useFieldPanelHelper,
}